import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {HttpErrorHandler} from '../../http.error.handler';
import {JsonApiResponse} from '../../shared/models/JsonApiResponse';
import {Dropdown, DropdownOption} from '../../shared/models/dvir';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DvirService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  getDropdownProviders() {
    return firstValueFrom(this.http.get<JsonApiResponse<DropdownOption[]>>(
      `${environment.services.service}v3/vehicle-inspection/question/dropdown/provider-list`, {}
    ).pipe(
      catchError(HttpErrorHandler.handleError),
      map(response => response.data)
    ));
  }

  getDropdownLists(provider: string) {
    return firstValueFrom(this.http.get<JsonApiResponse<Dropdown[]>>(
      `${environment.services.service}v3/vehicle-inspection/question/dropdown/${provider}/list`, {}
    ).pipe(
      catchError(HttpErrorHandler.handleError),
      map(response => response.data)
    ));
  }

}
